const allaccpayable = { data: [], loading: true };
export const GetAllAccPayable = (state = allaccpayable, action) => {
  switch (action.type) {
    case "get_allaccpayable":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
